import React, { useEffect, useState } from 'react';
import { initWebSocket, disconnectWebSocket, isWebSocketConnected, subscribeToChat, sendTyping } from '../api/websocket';
import { getAccessToken } from '../api/token';
import HrnbAlert from '../components/controls/HrnbAlert';
import HrnbButton from '../components/controls/HrnbButton';

/**
 * Страница для отладки WebSocket подключения
 */
export default function WebSocketTestPage() {
    const [status, setStatus] = useState('Не подключено');
    const [logs, setLogs] = useState([]);
    const [chatId, setChatId] = useState('1');

    const addLog = (message) => {
        setLogs(prev => [...prev, `${new Date().toLocaleTimeString()} - ${message}`]);
    };

    const handleConnect = () => {
        const token = getAccessToken();
        if (!token) {
            addLog('Токен не найден! Войдите в систему.');
            return;
        }

        addLog('Попытка подключения...');
        
        initWebSocket(
            (data) => {
                if (data.error) {
                    setStatus('Ошибка: ' + data.message);
                    addLog('Ошибка: ' + data.message);
                } else if (data.connected) {
                    setStatus('Подключено ✅');
                    addLog('WebSocket подключён успешно');
                }
            },
            (typingData) => {
                addLog('Typing event: ' + JSON.stringify(typingData));
            },
            token
        );

        // Проверяем статус через 2 секунды
        setTimeout(() => {
            const connected = isWebSocketConnected();
            setStatus(connected ? 'Подключено ✅' : 'Не подключено ❌');
            addLog('Статус после проверки: ' + connected);
        }, 2000);
    };

    const handleDisconnect = () => {
        disconnectWebSocket();
        setStatus('Отключено');
        addLog('WebSocket отключён');
    };

    const handleTestTyping = () => {
        const sent = sendTyping(chatId);
        addLog('Typing отправлено: ' + sent);
    };

    const handleTestSubscribe = () => {
        const sub = subscribeToChat(chatId, (msg) => {
            addLog('Получено сообщение: ' + JSON.stringify(msg));
        });
        if (sub) {
            addLog('Подписка на чат ' + chatId + ' создана');
        } else {
            addLog('Не удалось создать подписку');
        }
    };

    return (
        <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
            <h1>WebSocket Тест</h1>
            
            <div style={{ marginBottom: '20px' }}>
                <p><strong>Статус:</strong> {status}</p>
                <p><strong>Токен:</strong> {getAccessToken() ? 'Есть ✅' : 'Нет ❌'}</p>
            </div>

            <div style={{ marginBottom: '20px' }}>
                <input
                    type="text"
                    value={chatId}
                    onChange={(e) => setChatId(e.target.value)}
                    placeholder="Chat ID"
                    style={{ padding: '8px', marginRight: '10px', width: '100px' }}
                />
                <HrnbButton onClick={handleConnect} style={{ marginRight: '10px' }}>
                    Подключить
                </HrnbButton>
                <HrnbButton onClick={handleDisconnect} variant="secondary" style={{ marginRight: '10px' }}>
                    Отключить
                </HrnbButton>
                <HrnbButton onClick={handleTestSubscribe} variant="info" style={{ marginRight: '10px' }}>
                    Тест подписки
                </HrnbButton>
                <HrnbButton onClick={handleTestTyping} variant="warning">
                    Тест Typing
                </HrnbButton>
            </div>

            <div style={{ 
                background: '#f5f5f5', 
                padding: '15px', 
                borderRadius: '4px', 
                maxHeight: '400px', 
                overflow: 'auto',
                fontFamily: 'monospace',
                fontSize: '12px'
            }}>
                <h3>Логи:</h3>
                {logs.length === 0 ? (
                    <p style={{ color: '#999' }}>Нет логов</p>
                ) : (
                    logs.map((log, index) => (
                        <div key={index} style={{ marginBottom: '5px' }}>{log}</div>
                    ))
                )}
            </div>

            <div style={{ marginTop: '20px' }}>
                <HrnbAlert variant="info">
                    <strong>Инструкция:</strong>
                    <ol>
                        <li>Войдите в систему (получите токен)</li>
                        <li>Нажмите "Подключить"</li>
                        <li>Проверьте статус в консоли браузера (F12)</li>
                        <li>Попробуйте отправить тестовые события</li>
                    </ol>
                </HrnbAlert>
            </div>
        </div>
    );
}
